import React from 'react';
import type {
  ComponentProps,
  TranscriptCueElement,
} from '../../../types/aha-editor';
import { Node } from 'slate';
import { secondsToTime } from '../utils/Time';

interface TranscriptCueComponentProps
  extends ComponentProps<TranscriptCueElement> {}

const TranscriptCueComponent: React.FC<
  React.PropsWithChildren<TranscriptCueComponentProps>
> = ({ attributes, element, children }) => {
  const content = Node.string(element);
  const trailingWhitespace = /\s+$/.test(content);

  return (
    <span
      {...attributes}
      title={`${secondsToTime(element.cue_startTime)}-${secondsToTime(
        element.cue_endTime
      )}`}
      style={{ paddingRight: trailingWhitespace ? undefined : 5 }}
    >
      {children}
    </span>
  );
};

export default TranscriptCueComponent;
